import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { Domain } from './user-access.model';
import { UserAccessService } from './user-access.service';

export const accessGuard: CanActivateFn = (): true | UrlTree => {
  const access = inject(UserAccessService);
  const router = inject(Router);

  if (access.currentUser()) {
    return true;
  }

  return router.parseUrl(access.error() ? '/access-unavailable' : '/unauthorized');
};

export function domainGuard(domain: Domain): CanActivateFn {
  return (): true | UrlTree => {
    const access = inject(UserAccessService);
    return access.canAccess(domain) ? true : deniedRoute(access);
  };
}

export const globalAdminGuard: CanActivateFn = (): true | UrlTree => {
  const access = inject(UserAccessService);
  return access.isGlobalAdmin() ? true : deniedRoute(access);
};

function deniedRoute(access: UserAccessService): UrlTree {
  const router = inject(Router);
  return router.parseUrl(access.error() ? '/access-unavailable' : '/unauthorized');
}
